import propTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { SpinnerCircular } from "spinners-react";
import attach from "../../../../assets/icons/attach.svg";
import variantIcon from "../../../../assets/icons/myTest.svg";
import pdf from "../../../../assets/icons/quiz.svg";
import {
  default as course,
  default as test,
} from "../../../../assets/icons/test.svg";
import video from "../../../../assets/icons/video.svg";
import {
  setClipBoardData,
  setImportLearningPathData,
} from "../../../../redux/features/learningPath/importLearningPathSlice";

function Browse({
  data,
  setData,
  currentScreen,
  setCurrentScreen,
  variant,
  setCourse,
  setVariant,
  error,
  status,
  fetchNextPage,
  isFetchingNextPage,
}) {
  const dispatch = useDispatch();

  const observerRef = useRef(null);
  const lastItemRef = useRef(null);

  console.log("Current Screen : ", currentScreen);

  // Set up intersection observer to detect when user scrolls near the end
  useEffect(() => {
    const options = {
      root: null, // use viewport as root
      rootMargin: "0px 0px 200px 0px", // trigger 200px before bottom
      threshold: 0.1, // trigger when 10% of the target is visible
    };

    const handleObserver = (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting && status !== "loading") {
        // When last item is visible and not currently loading, fetch more data
        fetchNextPage();
      }
    };

    observerRef.current = new IntersectionObserver(handleObserver, options);

    // Observe the last item if it exists
    if (lastItemRef.current) {
      observerRef.current.observe(lastItemRef.current);
    }

    return () => {
      // Clean up observer on unmount
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [data, status, fetchNextPage]);

  function handleClick(item) {
    if (currentScreen === 1) {
      setCurrentScreen(2);
      setCourse(item);
    } else if (currentScreen === 2) {
      setCurrentScreen(3);
      setVariant(item);
    } else if (currentScreen > 2) {
      if (item.children && item.children.length > 0) {
        setCurrentScreen(currentScreen + 1);
        let x = currentScreen + 1;
        setData((prevData) => ({
          ...prevData,
          [x]: item.children,
        }));
      } else {
        alert("No subtiers found");
      }
    }
  }

  function returnIcon(item) {
    if ("assetId" in item) {
      let assetType = item.assetType.toLowerCase();
      if (assetType === "pdf" || assetType === "html") return pdf;
      if (assetType === "video") return video;
      else return test;
    }
    if ("learningPathId" in item) return null;
    if ("courseId" in item) return course;
    if ("variantId" in item) return variantIcon;
    else return null;
  }

  function handleCopyLPObject(LPobject) {
    dispatch(setImportLearningPathData(LPobject));
    const clipBoardData = variant.variantName + " > " + LPobject.name;
    dispatch(setClipBoardData(clipBoardData));
    setCurrentScreen(0);
  }

  return (
    <>
      {status === "loading" ? (
        <SpinnerCircular
          size={50}
          thickness={100}
          speed={100}
          color="#00ABFB"
          secondaryColor="#f3f4f6"
        />
      ) : error ? (
        <div className="h-[250px] w-full flex items-center justify-center ">
          {error}
        </div>
      ) : (
        <div className="grid  gap-4 mb-3 grid-cols-3 w-full ">
          {data &&
            data.map((item, index) => {
              // Add ref to the last item to observe it
              const isLastItem = index === data.length - 1;
              if (!item) return null;

              return (
                <div
                  key={
                    item.learningPathId ||
                    item.courseId ||
                    item.variantId ||
                    item.assetId
                  }
                  ref={isLastItem ? lastItemRef : null}
                  className="flex flex-row border  border-slate-400 rounded-lg p-3 gap-4 break-all"
                >
                  {!("assetPath" in item) && (
                    <img className="h-5 " src={returnIcon(item)} alt="" />
                  )}
                  <div className="flex w-full justify-between">
                    <p
                      className="text-sm cursor-pointer "
                      onClick={() => handleClick(item)}
                    >
                      {item.name ||
                        item.courseName +
                          (item.productGroupName &&
                            " - " + item.productGroupName) ||
                        item.variantName ||
                        item.assetName}
                    </p>
                    {"assetPath" in item && (
                      <img
                        className="cursor-pointer"
                        src={attach}
                        alt=""
                        onClick={() => handleCopyLPObject(item)}
                      />
                    )}
                  </div>
                </div>
              );
            })}

          {isFetchingNextPage && (
            <SpinnerCircular
              size={50}
              thickness={100}
              speed={100}
              color="#00ABFB"
              secondaryColor="#f3f4f6"
            />
          )}
        </div>
      )}
    </>
  );
}

Browse.propTypes = {
  data: propTypes.array,
  currentScreen: propTypes.number,
  setData: propTypes.func,
  setCurrentScreen: propTypes.func,
  fetchCourses: propTypes.func,
  setCourse: propTypes.func,
  variant: propTypes.object,
  setVariant: propTypes.func,
  error: propTypes.string,
  status: propTypes.string,
  fetchNextPage: propTypes.func,
  isFetchingNextPage: propTypes.bool,
};
export default Browse;
